module.exports = __webpack_public_path__ + "static/media/create-site-and-agent-step-1-es.fc17e7dd.png";